import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

export const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    videoPush: (state, action) => {
      const element = action.payload;
      if (!state.includes(element)) {
        state.push(element);
      }
    },
  },
});

export const { videoPush } = videoSlice.actions;

// ambil data media video
export const fetchVideos = async  (thumbnail_name, created_at, uid) => (dispatch) => {
  const fetchCall =
    thumbnail_name && created_at && uid
      ? `${process.env.REACT_APP_URL}/content-video?page=1&created_at=${created_at}&uid=${uid}&thumbnail_name=${thumbnail_name}`
      : `${process.env.REACT_APP_URL}/content-video?page=1`;
  fetch(fetchCall)
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      for (let i = 0; i < res.data.length; i++) {
        dispatch(videoPush(res.data[i]));
      }
    });
}

export const videosStore = (state) => state.video;

export const videosIsEmpty = (state) => state.video.length === 0;

export default videoSlice.reducer;
